import React from 'react';
import { LayoutDashboard, BarChart3, PieChart, Layers } from 'lucide-react';

const BusinessDashboard = () => {
  return (
    <div className="pt-24 bg-gray-950 min-h-screen text-left">
      <section className="py-20 bg-gradient-to-b from-gray-950 via-slate-900 to-gray-950 border-b border-gray-800">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <div className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-4">
            <LayoutDashboard className="w-4 h-4 text-orange-400" />
            <span className="text-orange-400 text-sm font-semibold uppercase tracking-wider">
              Real-Time BI & Analytics Dashboards
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
            Data-Driven Executive <span className="bg-gradient-to-r from-orange-400 via-amber-400 to-cyan-400 bg-clip-text text-transparent">Business Dashboards</span>
          </h1>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed">
            Transform raw company metrics into interactive data visualizations, real-time KPI trackers, automated PDF reporting, and executive BI dashboards.
          </p>
        </div>
      </section>

      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <BarChart3 className="w-10 h-10 text-cyan-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Real-Time Data Pipelines</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Live WebSocket data feeds, high-frequency chart rendering, and automated metric streaming.</p>
            </div>
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <PieChart className="w-10 h-10 text-orange-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Custom KPI Visualization</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Recharts and Chart.js integration for revenue forecasts, user conversion funnels, and churn rates.</p>
            </div>
            <div className="bg-gray-950 border border-gray-800 rounded-3xl p-8">
              <Layers className="w-10 h-10 text-amber-400 mb-6" />
              <h3 className="text-xl font-bold text-white mb-3">Role-Based Executive Views</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">Tailored UI views for CEOs, CFOs, Sales Managers, and Operations teams with granular access controls.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessDashboard;
